export const TRACKING_ID = 'G-BTSYN1C9TE';

export const GA4_EVENT_TYPE = {};
